import React, { Fragment } from 'react';
import { Collapse } from '@material-ui/core';
import MastercardIcon from './MastercardIcon.svg';
import DiscoverIcon from './DiscoverIcon.svg';
import AmericanExpressIcon from './AmericanExpressIcon.svg';
import VisaIcon from './VisaIcon.svg';
import { css } from 'react-emotion';
import Radio from './Radio';

const styles = {
  stripeButtonContainer: css({
    border: '2px solid #d9d9d9',
    backgroundColor: 'transparent',
    borderRadius: '0.25rem',
    minWidth: '150px',
    padding: '0.7rem 1rem',
    marginTop: '0.5rem',
  }),
  stripeButton: css({
    padding: '0.7rem 0',
    minHeight: '50px',
  }),
  radio: css({
    position: 'static',
    margin: '0',
  }),
  creditDebitSvg: css({
    marginLeft: '0.2rem',
  }),
};

const renderCreditDebitIcons = label => {
  if (label.toLowerCase().includes('credit')) {
    return (
      <Fragment>
        <MastercardIcon className={styles.creditDebitSvg} />
        <DiscoverIcon className={styles.creditDebitSvg} />
        <AmericanExpressIcon className={styles.creditDebitSvg} />
        <VisaIcon className={styles.creditDebitSvg} />
      </Fragment>
    );
  }
};
// class Signing = ({ numberOfSchools, pricePerSchool, handleFormInput }) =>
const StripeButton = ({
  radioId,
  icon,
  label,
  openAccordion,
  whichAccordionIsOpen,
  children,
}) => (
  <div
    data-testid={`click-openAccordion${radioId}`}
    onClick={() => openAccordion(radioId)}
  >
    <div
      className={`flex-auto pj-margin-left--narrow ${
        styles.stripeButtonContainer
      }`}
    >
      <div
        className={`layout-row layout-align-space-between-center ${
          styles.stripeButton
        }`}
      >
        <div className="layout-row layout-align-center-center">
          <Radio
            className={styles.radio}
            checked={whichAccordionIsOpen === radioId}
            data-testid={`click-radio${radioId}`}
            color="jungle"
          />
          <div className="pj-margin-left--wide">{label}</div>
        </div>

        <div className="layout-row layout-align-center-center">
          {renderCreditDebitIcons(label)}
        </div>
      </div>

      <Collapse in={whichAccordionIsOpen === radioId}>{children}</Collapse>
    </div>
  </div>
);

export default StripeButton;



// WEBPACK FOOTER //
// ./src/Onboarding/Registration/onboarding/containers/Payment/components/StripeButton.jsx